import styled from 'styled-components';
import { darkgrey, tabsBorder, tertiaryGrey } from 'styles/Colors';

export const ModalContent = styled.div`
  padding: 24px;
`;

export const ModalItem = styled.div`
  display: flex;
  justify-content: space-between;
  border: 1px solid ${tabsBorder};
  padding: 10px 16px;
  border-radius: 8px;
  margin-bottom: 16px;
  align-items: center;
  height: 56px;

  &:last-child {
    margin-bottom: 0;
  }
`;

export const ItemLabel = styled.div`
  font-size: 15px;
  font-weight: 700;
  color: ${darkgrey};
`;

export const ItemValue = styled.div`
  font-size: 15px;
  font-weight: 400;
  color: ${darkgrey};
`;

export const SupportCenter = styled.div`
  font-size: 15px;
  font-weight: 400;
  color: ${darkgrey};
  text-decoration: underline;
  cursor: pointer;
`;

export const ExternalLink = styled.a`
  display: flex;
  gap: 4px;
  align-items: center;
`;

export const Hint = styled.div`
  font-size: 11px;
  color: ${tertiaryGrey};
`;

export const SupportWrapper = styled.div`
  text-align: right;
`;
